import { localeType } from '@/enums';

export function dataURIToFile(dataURI, fileName) {
  const byteString = atob(dataURI.split(',')[1]);
  const type = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const buffer = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i += 1) {
    buffer[i] = byteString.charCodeAt(i);
  }

  return new File(
    [new Blob([new DataView(arrayBuffer)], { type })],
    fileName,
    { type },
  );
}

export function objectToFormData(object) {
  const form = new FormData();

  Object.keys(object).forEach((key) => {
    if (Array.isArray(object[key])) {
      object[key].forEach((value) => {
        form.append(`${key}[]`, value);
      });
    } else {
      form.append(key, object[key]);
    }
  });

  return form;
}

export function objectToFormDataNotNullValueFields(object) {
  const form = new FormData();

  Object.keys(object).forEach((key) => {
    if (Array.isArray(object[key])) {
      object[key].forEach((value) => {
        form.append(`${key}[]`, value);
      });
    } else if (object[key]) {
      form.append(key, object[key]);
    }
  });

  return form;
}

export function findObject(predicate, node, childrenPath) {
  if (predicate(node)) {
    return node;
  }
  if (node[childrenPath]) {
    for (const child of node[childrenPath]) {
      if (predicate(child)) {
        return child;
      }
      const result = findObject(predicate, child, childrenPath);
      if (result != null) {
        return result;
      }
    }
  }
  return null;
}

export function safeGet(o, props, defaultValue = null) {
  return props.reduce((acc, current) => ((acc && acc[current]) ? acc[current] : defaultValue), o);
}

export function arrayToObject(arr, key = 'id') {
  return Object.assign(Object.create(null), ...arr.map((i) => ({ [i[key]]: i })));
}

export function pick(object, keys) {
  return keys.reduce((acc, key) => {
    if (key in object) {
      acc[key] = object[key];
    }

    return acc;
  }, {});
}

export async function response(promise, defaultValue = null) {
  return safeGet(await promise, ['data', 'data'], defaultValue);
}

export function secondsToMinutes(seconds) {
  return Math.floor(seconds / 60);
}

export function normalizePhoneNumber(value) {
  if (value === null) {
    return null;
  }

  return String(value).replace(/[ -]/g, '');
}

export function readableSeconds(seconds) {
  const date = new Date(null);
  date.setSeconds(seconds);

  if (Math.floor(seconds / 3600) > 0) {
    return date.toISOString().substr(11, 8);
  }

  return date.toISOString().substr(14, 5);
}

export function compileNotificationTemplate(template, user, company, vacancy, candidate) {
  return template.replace(/\{company\.name}/gm, company.name)
    .replace(/\{hr\.firstName}/gm, user.firstName)
    .replace(/\{hr\.lastName}/gm, user.lastName)
    .replace(/\{hr\.phone}/gm, user.phone)
    .replace(/\{hr\.email}/gm, user.email)
    .replace(/\{vacancy\.title}/gm, vacancy.title)
    .replace(/\{candidate\.firstName}/gm, candidate.firstName)
    .replace(/\{candidate\.lastName}/gm, candidate.lastName)
    .replace(
      /\{interview\.link}/gm,
      `${process.env.VUE_APP_FRONT_URL}/h/${candidate.hashId}`,
    );
}

export function compileShareLinkNotificationTemplate(template, user, company, vacancy) {
  return template.replace(/\{company\.name}/gm, company.name)
    .replace(/\{hr\.firstName}/gm, user.firstName)
    .replace(/\{hr\.lastName}/gm, user.lastName)
    .replace(/\{hr\.phone}/gm, user.phone)
    .replace(/\{hr\.email}/gm, user.email)
    .replace(/\{vacancy\.title}/gm, vacancy.title)
    .replace(/\{vacancy\.link}/gm, vacancy.link);
}

export function getVariableValue(variable, template, user, company, vacancy) {
  const map = {
    'hr.firstName': user.firstName,
    'hr.lastName': user.lastName,
    'hr.phone': user.phone,
    'hr.email': user.email,
    'vacancy.title': vacancy.title,
    'vacancy.link': vacancy.link,
    'company.name': company.name,
  };
  return map[variable];
}

export function detectBrowserLocale() {
  const browserLocale = window.navigator.language || window.navigator.userLanguage;

  if (!browserLocale) {
    return localeType.DEFAULT;
  }

  const locale = browserLocale.split('-').shift();

  if (!locale || !Object.keys(localeType).includes(locale.toUpperCase())) {
    return localeType.DEFAULT;
  }

  return localeType[locale.toUpperCase()];
}

export function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getHostUrl() {
  return `${window.location.protocol}//${window.location.host}`;
}

export function extractUtm(query) {
  if (localStorage.getItem('utm_campaign') === null && query.utm_campaign) {
    localStorage.setItem('utm_campaign', query.utm_campaign);
  }
  if (localStorage.getItem('utm_content') === null && query.utm_content) {
    localStorage.setItem('utm_content', query.utm_content);
  }
  if (localStorage.getItem('utm_medium') === null && query.utm_medium) {
    localStorage.setItem('utm_medium', query.utm_medium);
  }
  if (localStorage.getItem('utm_source') === null && query.utm_source) {
    localStorage.setItem('utm_source', query.utm_source);
  }
  if (localStorage.getItem('utm_term') === null && query.utm_term) {
    localStorage.setItem('utm_term', query.utm_term);
  }
}

export function getUtm() {
  return {
    campaign: localStorage.getItem('utm_campaign'),
    content: localStorage.getItem('utm_content'),
    medium: localStorage.getItem('utm_medium'),
    source: localStorage.getItem('utm_source'),
    term: localStorage.getItem('utm_term'),
  };
}
